module.exports = __webpack_public_path__ + "static/media/21ECLAC6.e46f162a.jpg";